<template>
  <div :class="['subject-list-skeleton', `is-${variant}`]" aria-label="列表加载中">
    <template v-if="variant === 'filter'">
      <div v-for="group in 3" :key="group" class="filter-group">
        <span class="skeleton-line filter-title"></span>
        <span v-for="line in 5" :key="line" class="skeleton-line filter-line"></span>
      </div>
    </template>
    <template v-else>
      <div v-for="item in rows" :key="item" class="skeleton-row">
        <span class="skeleton-line row-index"></span>
        <span v-if="variant === 'journal'" class="skeleton-line row-cover"></span>
        <div class="row-content">
          <span class="skeleton-line row-title"></span>
          <div v-if="variant === 'author' || variant === 'institution'" class="row-metrics">
            <span v-for="metric in 3" :key="metric" class="skeleton-line row-metric"></span>
          </div>
          <span class="skeleton-line row-text is-long"></span>
          <span class="skeleton-line row-text"></span>
          <span v-if="variant !== 'news'" class="skeleton-line row-text is-short"></span>
          <div v-if="variant === 'article'" class="row-actions">
            <span v-for="action in 3" :key="action" class="skeleton-line row-action"></span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "SubjectListSkeleton",
  props: {
    variant: {
      type: String,
      default: "article",
    },
    rows: {
      type: Number,
      default: 5,
    },
  },
};
</script>

<style lang="scss" scoped>
.subject-list-skeleton {
  width: 100%;
  min-width: 0;
}

.skeleton-line {
  display: block;
  border-radius: 3px;
  background: linear-gradient(90deg, #f1f3f5 25%, #e4e8ec 37%, #f1f3f5 63%);
  background-size: 400% 100%;
  animation: subject-skeleton-loading 1.4s ease infinite;
}

@keyframes subject-skeleton-loading {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

.skeleton-row {
  display: flex;
  gap: 16px;
  min-width: 0;
  padding: 20px 0;
  border-bottom: 1px solid #edf2f5;
}

.row-index {
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
}

.row-cover {
  flex: 0 0 82px;
  width: 82px;
  height: 108px;
}

.row-content {
  flex: 1;
  min-width: 0;
}

.row-title {
  width: 58%;
  height: 20px;
  margin-bottom: 16px;
}

.row-text {
  width: 64%;
  height: 13px;
  margin-top: 11px;
}

.row-text.is-long { width: 88%; }
.row-text.is-short { width: 42%; }

.row-metrics,
.row-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 12px 0;
}

.row-metric {
  width: 100px;
  height: 18px;
}

.row-actions {
  justify-content: flex-end;
}

.row-action {
  width: 64px;
  height: 24px;
}

.is-filter {
  flex: 0 0 250px;
  width: 250px;
  margin-right: 20px;
  padding: 20px;
  background: #fff;
  box-sizing: border-box;
}

.filter-group + .filter-group { margin-top: 28px; }
.filter-title { width: 46%; height: 18px; margin-bottom: 16px; }
.filter-line { width: 88%; height: 13px; margin-top: 12px; }
.filter-line:nth-child(2n) { width: 68%; }

@media (max-width: 1024px) {
  .is-filter {
    flex: none;
    width: 100%;
    margin: 0 0 16px;
  }
}

@media (max-width: 768px) {
  .skeleton-row { gap: 10px; padding: 16px 0; }
  .row-index { flex-basis: 20px; width: 20px; height: 20px; }
  .row-cover { flex-basis: 58px; width: 58px; height: 78px; }
  .row-title { width: 78%; }
  .row-text, .row-text.is-long { width: 100%; }
  .row-text.is-short { width: 62%; }
  .row-metric { width: 76px; }
  .is-filter { padding: 16px 12px; }
}
</style>
